import { useState } from "react";
import { CalendarDays, ChevronDown } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { formatDateID, localeId } from "@/lib/format";

export const DateField = ({ value, onChange, id = "tanggal", testId = "input-tanggal", allowFuture = false }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          id={id}
          data-testid={testId}
          className="flex h-11 w-full items-center gap-3 rounded-xl border border-slate-200 bg-white px-3.5 text-left text-sm text-slate-900 transition-colors hover:border-emerald-300 focus:outline-none focus:ring-2 focus:ring-emerald-500/30"
        >
          <CalendarDays className="h-4 w-4 text-emerald-600" />
          <span className="flex-1" data-testid={`${testId}-value`}>{formatDateID(value, "EEEE, d MMMM yyyy")}</span>
          <ChevronDown className="h-4 w-4 text-slate-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto rounded-2xl p-0" align="start" data-testid={`${testId}-calendar`}>
        <Calendar
          mode="single"
          selected={value}
          onSelect={(d) => {
            if (!d) return;
            onChange(d);
            setOpen(false);
          }}
          locale={localeId}
          disabled={allowFuture ? undefined : { after: new Date() }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
};
